import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransformations_ds_inventory_transformations_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[], from_date?: string, to_date?: string, date_type?: string }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, LookupCode?: string, StatusId?: number, InventoryTransformationStatus?: { Name?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, Warehouse?: { Id?: number, Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_inventory_transformations_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[], from_date?: string, to_date?: string, date_type?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, LookupCode?: string, StatusId?: number, InventoryTransformationStatus?: { Name?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, Warehouse?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_inventory_transformations_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[], from_date?: string, to_date?: string, date_type?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, LookupCode?: string, StatusId?: number, InventoryTransformationStatus?: { Name?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, Warehouse?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_inventory_transformations_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[], from_date?: string, to_date?: string, date_type?: string    }) {
      return false;
    }
}
